<template>
  <div class="breadcrumb">
    <div class="breadcrumb-inner">
      <a
        class="route"
      >
        {{ featuredLabel }}
      </a>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.09056 6.00171L3.96484 2.87428L4.57142 2.26857L8.30284 6.002L4.57113 9.73143L3.96542 9.12514L7.09056 6.00171Z"
          fill="#232323"
          stroke="#232323"
          stroke-width="0.5"
        />
      </svg>

      <a
        class="route"
      >
        {{ categoryLabel }}
      </a>
    </div>
  </div>
</template>
<script setup>
import { TRANSALTE_MAP } from '@/utils/constants'
import { useLanguageStore } from '@/pinia/language'

const route = useRoute()

const language = useLanguageStore()
const featuredLabel = computed(() => TRANSALTE_MAP[language.current]?.featured)
const categoryLabel = computed(() => {
  const { category } = route.params
  return TRANSALTE_MAP[language.current]?.[category]
})

</script>
<style scoped lang="less">
@import "./index.less";
</style>
